/**
 * Runtime configuration, loaded from /config.js (a classic script tag in
 * index.html that sets window.__GFT_CONFIG__ before the app boots).
 *
 * - The per-env values are the committed config/<env>.js files; terraform
 *   copies the right one to S3 (aws_s3_object.runtime_config) — the bundle
 *   itself is env-agnostic.
 * - Local dev serves config/dev.js via the public/config.js symlink.
 *
 * Only true runtime values live here. Dev-only flags (VITE_API_MOCK,
 * VITE_AUTH_DISABLED) stay compile-time by design — the auth bypass must be
 * unreachable in production builds.
 */

export interface AppConfig {
  apiBaseUrl: string;
  auth0Domain: string;
  auth0ClientId: string;
}

declare global {
  interface Window {
    __GFT_CONFIG__?: Partial<AppConfig>;
  }
}

function required(value: string | undefined, key: string): string {
  if (!value) {
    throw new Error(
      `Missing "${key}" in config.js (window.__GFT_CONFIG__) — see public/config.js`,
    );
  }
  return value;
}

const raw = window.__GFT_CONFIG__;
if (!raw) {
  throw new Error(
    "config.js did not load — it must set window.__GFT_CONFIG__ before the app bundle runs",
  );
}

export const appConfig: AppConfig = {
  apiBaseUrl: required(raw.apiBaseUrl, "apiBaseUrl"),
  auth0Domain: required(raw.auth0Domain, "auth0Domain"),
  auth0ClientId: required(raw.auth0ClientId, "auth0ClientId"),
};
